import { LifetimeParametersForm } from '@hub/bearing-hub/libs/BearingsLifetime/LifetimeParametersForm';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Dialog } from '@hub/common/Dialog/Dialog';
import type { IbhShape } from '@igus/iglidur-bearing-hub-api';
import type { IbhUnitSystem } from '@igus/iglidur-bearing-hub-api/src/data-contracts';

export type LifetimeParameterModalProps = {
  visible: boolean;
  onLifeTimeModalClose: (isOpen: boolean) => void;
  onCalculateLifeTime: () => void;
  onReset: (unitSystem: IbhUnitSystem) => void;
  articleNumber?: string;
  unitSystem: IbhUnitSystem;
  shapeKey: IbhShape;
};

export const LifetimeParametersModal = ({
  visible,
  onLifeTimeModalClose,
  onCalculateLifeTime,
  onReset,
  articleNumber,
  unitSystem,
  shapeKey,
}: LifetimeParameterModalProps) => {
  const { t } = useTranslation();
  return (
    <Dialog closable onClose={() => onLifeTimeModalClose(false)} visible={visible}>
      <div className="p-8 overflow-auto">
        <h3 data-testId="life-Time-Modal_Header">
          {articleNumber
            ? t('LIFETIME.LIFE_TIME_MODAL_HEADER', {
                ns: 'bearing-hub/bearingHub',
                articleNumber,
              })
            : t('HEADLINES.LIFETIME', { ns: 'bearing-hub/bearingHub' })}
        </h3>
        <LifetimeParametersForm
          unitSystem={unitSystem}
          isEmbedded
          onCalculate={onCalculateLifeTime}
          onReset={() => onReset(unitSystem)}
          shapeKey={shapeKey}
        />
      </div>
    </Dialog>
  );
};
